// Ubicación en el repo: src/lib/categories.js
// Categorías de producto del catálogo (migración 0046, Fase A del módulo
// de Inventario/Contabilidad — ver plan-inventario-y-contabilidad.md,
// 24-ago-2026). Reemplaza el enum fijo `catalog.type` (SUPPLY_TYPES) por
// una entidad administrable — mismo criterio que branches.js: RLS
// `categories_insert/_update` exige Admin/bootstrap, lectura abierta a
// cualquier autenticado (la necesita el formulario de producto).
//
// `special_role` (migración 0050, 25-ago-2026) marca la categoría que la
// venta de audífonos (HearingAidFormModal.jsx) y el toggle Pila/Recargable
// (CatalogFormModal.jsx) usan para reconocer "esta es la categoría de
// audífonos" — reemplaza la comparación frágil por nombre exacto
// ("Audífono", con tilde, singular) que existía antes: ahora se puede
// renombrar la categoría libremente sin romper esos dos flujos, siempre
// que el flag `special_role = 'audifono'` se mantenga en la misma fila.
// Texto libre, no un enum fijo — pensado para poder reusar el mismo
// mecanismo con otra categoría especial en el futuro sin otra migración.
import { supabase } from './supabaseClient';

export async function listActiveCategories() {
  const { data, error } = await supabase
    .from('categories')
    .select('id, name, special_role')
    .is('deleted_at', null)
    .order('name', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function listAllCategoriesForAdmin() {
  const { data, error } = await supabase
    .from('categories')
    .select('id, name, special_role, deleted_at')
    .order('name', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function createCategory(name, specialRole) {
  const { data, error } = await supabase
    .from('categories')
    .insert({ name: name.trim(), special_role: specialRole || null })
    .select('id')
    .single();
  if (error) throw error;
  return data.id;
}

export async function updateCategory(id, name, specialRole) {
  const { error } = await supabase
    .from('categories')
    .update({ name: name.trim(), special_role: specialRole || null })
    .eq('id', id);
  if (error) throw error;
}

export async function softDeleteCategory(id, actorId) {
  const { error } = await supabase
    .from('categories')
    .update({ deleted_at: new Date().toISOString(), deleted_by: actorId })
    .eq('id', id);
  if (error) throw error;
}

export async function restoreCategory(id) {
  const { error } = await supabase.from('categories').update({ deleted_at: null, deleted_by: null }).eq('id', id);
  if (error) throw error;
}
